export default "__VITE_ASSET__B7i8c8V8__"